import { render, staticRenderFns } from "./UserUploadedDocs.vue?vue&type=template&id=25126ab3&scoped=true&"
import script from "./UserUploadedDocs.vue?vue&type=script&lang=js&"
export * from "./UserUploadedDocs.vue?vue&type=script&lang=js&"
import style0 from "./UserUploadedDocs.vue?vue&type=style&index=0&id=25126ab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25126ab3",
  null
  
)

export default component.exports